import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logoImage from "../img/logo.webp";
import visa from "../img/visa.png";
import master from "../img/mastercard-logo-png-transparent.png";
import paynet from "../img/logopaynet.webp";

const Footer = () => {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column footer-contact">
          <div className="logo">
            <img src={logoImage} alt="Logo" className="logo-img"></img>
          </div>
          <div className="location">
            <a
              href="https://www.google.com/maps/place/Strada+Petru+Rareș+37,+Chișinău,+Moldova/"
              target="_blank"
              rel="noopener noreferrer"
              className="map-link btn"
            >
              Str. Petru Rareș 37, Chișinău, Moldova
            </a>
            <div className="contact-info">
              <a href="tel:+37378774774" className="phone btn">
                Tel: +373 78 774 774
              </a>
              <a href="mailto:order@gardeniaflowers.md" className="email btn">
                Email: order@gardeniaflowers.md
              </a>
            </div>
          </div>
          <div className="working-hours">
            <p>Luni-Vineri: 8:30 - 20:00</p>
            <p>Sâmbătă: 9:00 - 19:00</p>
            <p>Duminică: 11:00 - 17:00</p>
          </div>
          <p>Florelite Design SRL</p>
          <p>IDNO: 1022600015904</p>
          <p>Adr. jur.: N. Costin 65/3, 17, Chișinău</p>
        </div>

        <div className="footer-column footer-categories">
          <h3 className="footer-item">Categorii</h3>
          <ul className="footer-links">
            <li>
              <Link className="btn footer-link" to="/cele-mai-vindute">
                Cele mai vindute
              </Link>
            </li>
            <li>
              <Link
                className="btn footer-link"
                to="/buchete-trandafiri"
                tabIndex={-1}
              >
                Buchete din trandafiri
              </Link>
            </li>
            <li>
              <Link
                className="btn footer-link"
                to="/compozitii-in-cosuri-si-cutii"
              >
                Buchete in cosuri si cutii
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/buchete-premium">
                Buchete Premium
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/buchete-de-mireasa">
                Buchete de mireasa
              </Link>
            </li>
            <li>
              <Link
                className="btn footer-link"
                to="/buchete-de-iarna/primavara"
              >
                Buchete de primavara
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column footer-info">
          <h3 className="footer-item">Informatii utile</h3>
          <ul className="footer-links">
            <li>
              <Link className="btn footer-link" to="/despre-noi">
                Despre noi
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/livrare-si-plata">
                Contact
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/livrare-si-plata">
                Livrare si plata
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/intrebari-frecvente">
                Intrebari frecvente
              </Link>
            </li>
            <li>
              <Link className="btn footer-link" to="/termeni-si-conditii">
                Termeni & Conditii
              </Link>
            </li>
            <li>
              <Link
                className="btn footer-link"
                to="/politica-de-confidentialitate"
              >
                Politica de Confidentialitate
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-divider-container">
        <hr className="footer-divider" />
      </div>

      <div className="footer-bottom">
        <div className="footer-social">
          <div>
            <a
              href="https://www.instagram.com/gardeniaflowers_md/"
              className="social__media--link btn"
              title="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-instagram social__media--icon"></i>
            </a>
          </div>
          <div>
            <a
              href="https://www.facebook.com/profile.php?id=100083015576175"
              className="social__media--link btn"
              title="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-facebook social__media--icon"></i>
            </a>
          </div>
          <div>
            <a
              href="https://wa.me/37378774774"
              className="btn social__media--link"
              title="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-whatsapp social__media--icon"></i>
            </a>
          </div>

          <a
            href="https://t.me/+37378774774"
            className="btn social__media--link"
            title="Telegram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-telegram social__media--icon"></i>
          </a>
        </div>
        <div className=" footer-copyright">
          <p className="copyright">
            &copy; <span className="year">{getCurrentYear()}</span> Gardenia
            Flowers. Toate drepturile sunt rezervate.
          </p>
        </div>

        <div className="footer-payments">
          <img className="footer-payment-img" src={visa} alt="Card" />
          <img className="footer-payment-img" src={master} alt="Card" />
          <img className="footer-payment-img" src={paynet} alt="Card" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
